module.exports = __webpack_public_path__ + "assets/img/logoDark1.ff85afee.svg";